@if (shouldShowIconBar) {
  <div class="icon-bar d-none d-md-flex flex-column align-items-center position-fixed border-top border-end border-bottom shadow p-m gap-1">
    @for (icon of navService.userMenu(); track $index) {
      <app-tooltip
        [text]="(icon.name | translate)"
        [opensOn]="'Auto'"
        [position]="'RightCenter'">
        <app-form-button
          [style]="'btn'"
          [cssClass]="'btn-link p-m'"
          [iconClass]="'text-' + icon.color + ' fs-4'"
          [icon]="icon.icon"
          (click)="routerService.navigateTo(icon.route)">
        </app-form-button>
      </app-tooltip>
    }
  </div>
}
